import { Box, TextField, Typography, useTheme } from "@mui/material";
import React, { ChangeEvent, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left.svg";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import ButtonTabbar from "../../../components/ButtonTabbar";
import WalletChecked from "../../../../media/images/icons/wallet-checked";
import { useAppSelector } from "../../../../hooks/useRedux";
import { addCommas, digitsEnToFa } from "@persian-tools/persian-tools";
import InfoCircle from "../../../../media/images/icons/info-circle";
import InfoFillCircle from "../../../../media/images/icons/infofill-circle";
import Sinabank from "../../../../media/images/Sina-bank-logo-Vector 1.svg";
import IdentityCheck from "../../../../media/images/icons/identity-check";

export default function WithdrawWallet() {
  const [tabIndex, setTabIndex] = useState(0);

  const [checkoutValue, setCheckoutValue] = useState("");

  const { themeMode } = useAppSelector((state) => state.setting);

  const theme = useTheme();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const sanitizedValue = inputValue.replace(/\D/g, ""); // Remove non-numeric characters
    setCheckoutValue(digitsEnToFa(addCommas(sanitizedValue)));
  };

  const tabbuttons = [
    {
      title: "درخواست جدید",
    },
    {
      title: "درخواست‌های فعال",
    },
  ];
  return (
    <>
      <MobileHeader title={HeadTitle()} hasScroll={false} />
      <Box
        sx={{
          flex: 1,
          paddingX: "15px",
        }}
      >
        <Box
          sx={{
            padding: "14px 12px",
            backgroundColor: "background.default",
            borderWidth: "0.5px",
            borderStyle: "solid",
            borderColor: "info.main",
            borderRadius: "10px",
            paddingBottom: "100px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <ButtonTabbar
            activeIndex={tabIndex}
            handleChangeTab={(index) => setTabIndex(index)}
            buttons={tabbuttons}
          />
          <Box
            sx={{
              paddingX: "6px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "4px 8px",
                  backgroundColor: "success.light",
                  borderRadius: "5px",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "2px",
                  }}
                >
                  <WalletChecked size={14} color={theme.palette.success.main} />
                  <Typography
                    variant="body2"
                    sx={{
                      color: themeMode === "dark" ? "#fff" : "textColor.main",
                    }}
                  >
                    جمع کل کرایه بار(قابل برداشت):
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                  }}
                >
                  <Typography variant="h6" color={"success.main"}>
                    {digitsEnToFa(addCommas(85000000000))}
                  </Typography>
                  <Typography variant="h6">ریال</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              paddingX: "6px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="body2">مقدار درخواست برداشت</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                borderColor: "textColor.light",
                borderStyle: "solid",
                borderWidth: "1px",
                borderRadius: "10px",
              }}
            >
              <TextField
                placeholder="مقدار برداشت را به ریال وارد کنید "
                type="tel"
                value={checkoutValue}
                onChange={(e) => {
                  const value = addCommas(e.target.value);

                  console.log(value);

                  setCheckoutValue(digitsEnToFa(value));
                }}
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  "& .MuiInputBase-input": {
                    textAlign: "right",
                    border: "none !important",
                    outline: "none !important",
                    fontFamily: "YeBakh-SemiBold",
                    fontSize: "12px",
                    padding: "12px 12px",
                  },
                  "& .MuiInputBase-root": {
                    border: "none !important",
                    outline: "none !important",
                  },
                  border: "none",
                }}
              />
              <Box
                sx={{
                  borderRight: "solid",
                  borderColor: "textColor.light",
                  borderWidth: "1px",
                  height: "41.5px",
                  display: "flex",
                  alignItems: "center",
                  paddingX: "4px",
                  backgroundColor: "",
                }}
              >
                <Typography variant="body6">ریال</Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <InfoFillCircle size={20} color={theme.palette.secondary.dark} />
              <Typography variant="body6" color={"secondary.dark"}>
                حداقل مقدار برداشت {digitsEnToFa(addCommas(1000000))} ریال است
              </Typography>
            </Box>

            <Box
              sx={{
                mt: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  justifyContent: "center",
                }}
              >
                <Typography variant="body2">کارت بانکی شما</Typography>
              </Box>
              <Box
                sx={{
                  mt: 1,
                  borderRadius: "10px",
                  border: "solid",
                  borderColor: "textColor.light",
                  borderWidth: "1px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <img src={Sinabank} alt="" />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "3px",
                    }}
                  >
                    <Typography color={"primary.main"} variant="body2">
                      رضا یعقوبی فریان‌پور
                    </Typography>
                    <Box>
                      <Typography color={"textColor.light"} variant="body7">
                        بانک ایران زمین
                      </Typography>
                      <Box
                        sx={{
                          width: "fit-content",
                          paddingX: "4px",
                          backgroundColor: "success.light",
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                          paddingY: "2px",
                          borderRadius: "5px",
                        }}
                      >
                        <Box
                          sx={{
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                          }}
                        >
                          <IdentityCheck
                            size={16}
                            color={theme.palette.success.main}
                          />
                        </Box>
                        <Typography color={"success.main"} variant="body10">
                          احراز شده
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                  }}
                >
                  <Typography variant="body2">
                    {digitsEnToFa("10234567890123456")}
                  </Typography>
                  <Typography variant="body7">
                    IR {digitsEnToFa("01234567890123456")}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            ></Box>
          </Box>
        </Box>
      </Box>

      <BottomTabbar />
    </>
  );
}

function HeadTitle() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: "secondary.main",
        }}
      >
        کیف پول
      </Typography>
      <img src={ArrowTickLeft} alt="" />
      <Typography
        variant="body2"
        sx={{
          color: "secondary.main",
        }}
      >
        برداشت پول{" "}
      </Typography>
    </Box>
  );
}
